import { useCallback, useState } from "react";

import debounce from "lodash/debounce";

const useDebounceState = <T>(
  defaultValue: T,
  timeoutDefault?: number
): [T | null, (e: T) => void] => {
  const [debouncedState, setDebouncedState] = useState<T | null>(defaultValue);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFn = useCallback(
    debounce((e) => {
      setDebouncedState(e as T);
    }, timeoutDefault || 700),
    []
  );

  return [debouncedState, debounceFn];
};

export default useDebounceState;
